var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.6,
    height: 32,
    viewBox: "0 0 44.6 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Docker",
    transform: "translate(-762 -608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M65.053,280.637a5.858,5.858,0,0,0-3.641-.952,11.572,11.572,0,0,0-1.882.165,7.092,7.092,0,0,0-3.186-4.778L55.7,274.7l-.414.6a8.845,8.845,0,0,0-1.138,2.648,6.285,6.285,0,0,0,.745,4.944,8.775,8.775,0,0,1-3.248.786H22.276a1.386,1.386,0,0,0-1.386,1.386,20.931,20.931,0,0,0,1.282,7.55,11.323,11.323,0,0,0,4.468,5.813c2.193,1.345,5.771,2.11,9.8,2.11a30.072,30.072,0,0,0,5.44-.5A22.452,22.452,0,0,0,49,297.454a19.476,19.476,0,0,0,4.84-3.972,26.335,26.335,0,0,0,4.737-8.171h.414a6.806,6.806,0,0,0,4.985-1.882,5.509,5.509,0,0,0,1.324-1.944l.186-.538Z",
    transform: "translate(741.113 339.464)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M39.452,297.82h3.93a.349.349,0,0,0,.352-.352h0v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.362.362,0,0,0,.352.352h0",
    transform: "translate(726.667 324.474)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M65.652,297.82h3.93a.349.349,0,0,0,.352-.352h0v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352v3.516a.362.362,0,0,0,.352.352",
    transform: "translate(705.887 324.474)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M92.352,297.82h3.93a.349.349,0,0,0,.352-.352h0v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.337.337,0,0,0,.352.352h0",
    transform: "translate(684.71 324.474)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M118.652,297.82h3.93a.349.349,0,0,0,.352-.352v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.349.349,0,0,0,.352.352h0",
    transform: "translate(663.85 324.474)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M65.652,273.52h3.93a.362.362,0,0,0,.352-.352v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352v3.516a.378.378,0,0,0,.352.352",
    transform: "translate(705.887 343.747)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M92.352,273.52h3.93a.362.362,0,0,0,.352-.352v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.349.349,0,0,0,.352.352",
    transform: "translate(684.71 343.747)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M118.652,273.52h3.93a.362.362,0,0,0,.352-.352v-3.516a.362.362,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.362.362,0,0,0,.352.352",
    transform: "translate(663.85 343.747)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M118.652,249.12h3.93a.349.349,0,0,0,.352-.352v-3.516a.362.362,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.362.362,0,0,0,.352.352",
    transform: "translate(663.85 363.1)",
    fill: "#0091e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M145.152,297.82h3.93a.349.349,0,0,0,.352-.352v-3.516a.349.349,0,0,0-.352-.352h-3.93a.349.349,0,0,0-.352.352h0v3.516a.362.362,0,0,0,.352.352",
    transform: "translate(642.832 324.474)",
    fill: "#0091e2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/Docker.8bda3254b8cc2a21bdc3357020633d9e.svg";
export { ForwardRef as ReactComponent };